import PropTypes from 'prop-types';

export const SyncModelFormStatePropType = PropTypes.shape({
    selectedAll: PropTypes.oneOf(['plan', 'live']),
    ignored: PropTypes.bool,
    showIdentical: PropTypes.bool,
    data: PropTypes.object,
});
